import { breakpoints } from 'src/styles/breakpoints';
import styledBreakpoint from '@humblebee/styled-components-breakpoint';

export const breakpoint = styledBreakpoint(breakpoints.values);
